import { URL, API_URL, APPLICATION_TOKEN } from 'utils/consts';

export const TOKEN = 'token';
export const GET = 'GET';
export const POST = 'POST';
export const PUT = 'PUT';
export const DELETE = 'DELETE';

export { URL, API_URL, APPLICATION_TOKEN };
